// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-spdm-red[data-v-8480d33a]{color:#ab2430}.c-spdm-white[data-v-8480d33a]{color:#fff}#loadingPart[data-v-8480d33a]{background:hsla(0,0%,100%,.51);display:table;height:calc(var(--vh)*100);left:0;position:fixed;top:0;width:100vw;z-index:1070}#loadingPart .message[data-v-8480d33a]{display:table-cell;text-align:center;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
